import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodayBtwo = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech Industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Are You Ready to Contact With Us?
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-xl-8">
        <div className="service-details__content">
          {/* Existing content */}
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>
          <h2 className="title-animation mb-20">Notified Body Transition</h2>

<p className="mb-20">
  We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
</p>
          <h3 className="title-animation mb-20">b)	Fill up the Gap by Medical Writing:</h3>

<p className="mb-20">
We support you in medical writing all documents required in a clinical evaluation process or clinical investigations. Our experts utilize templates and forms to ensure the completeness and regulatory compliance of these numerous documents.
</p>
  <h4 className="title-animation mb-15">
            How SQUARE MEDTECH Can Help in Data & Investigation Site Management?
          </h4>
          <ul className="mb-40">
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Biostatistics
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Data Protection
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              General Data Management
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Site Selection
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Site Monitoring
            </li>
            <li>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
              Site Management
            </li>
          </ul>
          <h4 className="title-animation mb-15"><i className="fa-solid fa-vial text-primary"></i> Clinical Investigation</h4>
          <p>
            Clinical investigations are the most dependable approach to provide high-quality data concerning the safety & performance of a medical device. SQUARE MEDTECH offers assistance and experience in planning, preparation, and execution of clinical investigations considering NB requirements.
          </p>

          <h4 className="title-animation mb-15"><i className="fa-solid fa-vial text-primary"></i> Clinical Investigation Planning</h4>
          <p>
            Starting early in planning the collection of clinical evidence during product development is essential for timely market entry. We assist our clients in aligning clinical development planning with regulatory requirements, business strategies, and budgets. Our team will be assembled to design and develop your clinical investigation, ensuring seamless collaboration with our medical device team and consultants to support you for optimal results.
          </p>

          <h4 className="title-animation mb-15"><i className="fa-solid fa-vial text-primary"></i> Clinical Investigation Project Management</h4>
          <p>
            We collaborate closely with you to efficiently lead your clinical investigation project, saving both time and resources. Our team, comprising experienced project managers, monitors, medical writers, data managers, and medical advisors, offers a range of services according to your needs. Whether you require specific services or a complete solution, we are dedicated to supporting your project with the expertise and resources necessary to ensure success.
          </p>

          <h4 className="title-animation mb-15"><i className="fa-solid fa-vial text-primary"></i> Regulatory Submissions</h4>
          <p>
            We possess in-depth knowledge of the often intricate local and EU MDR, as well as FDA regulations and requirements for clinical investigations. Regardless of the regulatory objectives of your clinical investigation, we ensure our clients remain compliant and maintain excellent communication with ethical committees and regulatory authorities.
          </p>
          <p>
            Our extensive experience in preparing regulatory documents consistently results in efficient and successful outcomes. We guarantee that safety reporting, a critical component of any clinical investigation, is conducted meticulously in accordance with all applicable requirements.
          </p>

        
          <div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i> Our Expertise in Clinical Investigation</h4>
                <p>
                SQUARE MEDTECH excels in clinical investigation, offering end-to-end support for medical device trials. Our expertise includes study design, protocol development, site selection, data analysis, and regulatory compliance. We ensure high-quality, evidence-based results, accelerating approvals and market entry with precision, efficiency, and adherence to global regulatory standards.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15"><i class="fa fa-circle-o text-danger"></i> Why Choose Us for Clinical Investigation</h4>
                <p>
                Choose SQUARE MEDTECH for clinical investigation excellence. We consistently deliver innovative, robust study design, regulatory compliance, and precise data analysis, accelerating approvals and minimizing risk to produce reliable, evidence-based outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                        <ul  class="color-white mb-0">
                        <li>Investigator site file</li>
                        <li>CRFs & Questionnaires</li>
                        <li> Clinical investigation plan </li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                        <ul  class="color-white mb-0">
                        <li>Safety documents</li>
                        <li>Registration of clinical studies</li>
                        <li> Literature search & Publications</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>
    </>
  )
}
